module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAWCAYAAADafVyIAAAA6UlEQVRIS+WVoUqEURBGz6dPsBaTzWZZMKrBarIY1mTwIQyLUeuK+wZ2sYhgk4V9Ad9DEG2GIxdWtO1/+bmw4JRbZuZwZ+abiXoHHAPh176AyyS36iYwB8pbYwIPUT+Ae+DpT/QI2EhyoF4Bp8BFTXbgsMQVwCcwTjL5SaBOgWGSfXUMnCXZrgGo58BkJQDXwEnLH+wCLzXlWfiuA69LS1Sc1S1grxLyDjx3BawBR5WAtyTzpQB1B5gBg0pAcX/sAujT5JsugP+tg04latvkhQ7ajWlzoaltV4XaRwersa57C635yWx69L8B3mNFolUmbdQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/canvasImg/panel/leibie1@2x.png
// module id = FLBu
// module chunks = 14